module.exports = __webpack_public_path__ + "static/media/ImageMkulima.667f18bb.png";